import Carousel from "react-bootstrap/Carousel";
import {trackGalleryScrollLeft, trackGalleryScrollRight} from "../GoogleTagManager.utils";
import comingSoonIMG from "../../images/image_coming_soon-min.png";
import React from "react";
import {useDispatch} from "react-redux";
import {primaryVehicleCarousel, setCarouselIndex, setVehicleCode, setVehicleIndex, swapCompareImages} from "../../slices/vehicleSlice";


const PrimaryVehicle = ({vehicleCode, props, selectSliderImage, getCompareImages, buildCarousel}) => {
    const dispatch = useDispatch();
    return (
        <div className={'primaryImage'}>
            <Carousel
                indicators={false}
                interval={null}
                variant={"dark"}
                onSelect={
                    (eventKey) => {
                        if (eventKey > vehicleCode) {
                            trackGalleryScrollRight(props)
                        } else if (eventKey < vehicleCode) {
                            trackGalleryScrollLeft(props)
                        }
                        dispatch(setVehicleCode(eventKey))
                        selectSliderImage(eventKey)
                        dispatch(primaryVehicleCarousel(true))
                        dispatch(setVehicleIndex(eventKey))
                        dispatch(setCarouselIndex(eventKey))
                        dispatch(swapCompareImages({ swapTriggered: false }));
                    }
                }
                activeIndex={vehicleCode}>
                {
                    // Check if media object exists and has a length greater than zero, if not, display "comingSoon" image
                    Object.values(getCompareImages[0]?.media[Object.keys(getCompareImages[0]?.media)[0]])
                        .length > 0 ? (
                        Object.values(getCompareImages[0].media[Object.keys(getCompareImages[0].media)[0]])
                            .map(buildCarousel)
                    ) : (
                        <Carousel.Item key="comingSoon">
                            <div className={'photo-section'}>
                                <img src={comingSoonIMG} className={'compare-slider-photo'} alt={"comingSoon"}/>
                            </div>
                        </Carousel.Item>
                    )
                }
            </Carousel>
        </div>
    );
}

export default PrimaryVehicle;